// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-PJOE","type":"styles_type__28HFK","choices":"styles_choices__FXsFK"};